import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IMeeting } from 'app/shared/model/meeting.model';
import { getEntities as getMeetings } from 'app/entities/meeting/meeting.reducer';
import { IRecordedMeeting } from 'app/shared/model/recorded-meeting.model';
import { getEntity, updateEntity, createEntity, reset } from './recorded-meeting.reducer';

export const RecordedMeetingUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const meetings = useAppSelector(state => state.meeting.entities);
  const recordedMeetingEntity = useAppSelector(state => state.recordedMeeting.entity);
  const loading = useAppSelector(state => state.recordedMeeting.loading);
  const updating = useAppSelector(state => state.recordedMeeting.updating);
  const updateSuccess = useAppSelector(state => state.recordedMeeting.updateSuccess);

  const handleClose = () => {
    navigate('/recorded-meeting' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMeetings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...recordedMeetingEntity,
      ...values,
      meeting: meetings.find(it => it.id.toString() === values.meeting.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...recordedMeetingEntity,
          meeting: recordedMeetingEntity?.meeting?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.recordedMeeting.home.createOrEditLabel" data-cy="RecordedMeetingCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.recordedMeeting.home.createOrEditLabel">Create or edit a RecordedMeeting</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="recorded-meeting-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.recordedMeeting.recordedMeetingId')}
                id="recorded-meeting-recordedMeetingId"
                name="recordedMeetingId"
                data-cy="recordedMeetingId"
                type="text"
              />
              <ValidatedField
                id="recorded-meeting-meeting"
                name="meeting"
                data-cy="meeting"
                label={translate('fivePlusApp.recordedMeeting.meeting')}
                type="select"
              >
                <option value="" key="0" />
                {meetings
                  ? meetings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/recorded-meeting" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RecordedMeetingUpdate;
